import pricelistGroup from "./pricelistGroup";
import pricelist from "./pricelist";

export default (vm) => {
	vm.$store.registerModule("pricelistGroup", pricelistGroup(vm));
	vm.$store.registerModule("pricelist", pricelist(vm));
};
